var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('router-view'),_c('van-tabbar',{attrs:{"route":""}},[_c('van-tabbar-item',{attrs:{"to":"/home","icon":"home-o"}},[_vm._v("首页")]),_c('van-tabbar-item',{attrs:{"to":"/appointment","icon":"calendar-o"}},[_vm._v("预约")]),_c('van-tabbar-item',{attrs:{"to":"/user","icon":"manager-o"}},[_vm._v("我的")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }